export const BAD_REQUEST = 400;
export const UNAUTHORIZED = 401;
export const FORBIDDEN = 403;
export const NOT_FOUND = 404;
export const CONFLICT = 409;
export const UNSUPPORTED_MEDIA_TYPE = 415;
export const CREDENTIAL_CHANGE_REQUIRED = 452;
export const USER_NOT_CONFIRMED = 453;
